import styled, { css } from 'styled-components';

import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const Block = styled.div`
    display: block;
    width: 100%;
    
    & > div {
        display: block;
    }
`;

/**
 * Двухколоночный шаблон для страницы
 */
export const DoubleColumnLayout = styled(WideContainer)<{ isHide?: boolean }>`
    display: grid;
    flex-wrap: nowrap;
    grid-template-columns: 1fr 480px;
    gap: 32px;
    max-width: 100%;

    ${({ isHide = false }) => isHide && css`
        opacity: 0;
        height: 0;
        overflow: hidden;
    ` };

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        grid-template-columns: 1fr 384px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        grid-template-columns: 100%;
    }
`;

export const StageWrap = styled.section`
    display: flex;
    flex-direction: column;
    row-gap: 16px;
`;

export const Section = styled.section`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const BlocksWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 16px;
`;

export const BtnWrap = styled.div`
    width: 100%;
    flex-direction: column;
    align-items: flex-start;

    @media (max-width: ${wideBreakpoints.mobile}) {
        align-items: stretch;
    }
`;
